import React,{useState} from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Box, Button, CardActions } from '@mui/material';
import RolesStyles from './Roles.module.css'
import Modal from '@mui/material/Modal';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useEffect } from 'react';
import axios from 'axios';
// import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom'
// import this for redux read write
import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'
import { fetchNotifications } from '../../state/GlobalState'
import { useLocation, useNavigate } from 'react-router-dom';



const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  height:485,
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 2,
  p: 4,
};

const setimg = [
  {
    // title: 'Total 4 users',
    // description: 'Administrator',
    // content: ' Edit Role',
    images: [
      'https://res.cloudinary.com/dxluokypg/image/upload/v1682595163/profile.png_p7dlsz.svg',
      'https://res.cloudinary.com/dxluokypg/image/upload/v1682614938/profile2.png_ex2vgw.svg',
      'https://res.cloudinary.com/dxluokypg/image/upload/v1682614938/profile3.png_we8ngj.svg',
      'https://res.cloudinary.com/dxluokypg/image/upload/v1682614938/profile4.png_ubdjcv.svg'
    ]
  },
]
//   {
//     // title: 'Total 7 users',
//     // description: 'Manager',
//     // content: ' Edit Role',
//     images: [
//       'https://res.cloudinary.com/dxluokypg/image/upload/v1682595163/profile.png_p7dlsz.svg',
//       'https://res.cloudinary.com/dxluokypg/image/upload/v1682614938/profile2.png_ex2vgw.svg',
//       'https://res.cloudinary.com/dxluokypg/image/upload/v1682614938/profile3.png_we8ngj.svg',
//       'https://res.cloudinary.com/dxluokypg/image/upload/v1682614938/profile4.png_ubdjcv.svg'
//     ]
//   },
//   {
//     // title: 'Total 5 users',
//     // description: 'Users',
//     // content: ' Edit Role',
//     images: [
//       'https://res.cloudinary.com/dxluokypg/image/upload/v1682595163/profile.png_p7dlsz.svg',
//       'https://res.cloudinary.com/dxluokypg/image/upload/v1682614938/profile2.png_ex2vgw.svg',
//       'https://res.cloudinary.com/dxluokypg/image/upload/v1682614938/profile3.png_we8ngj.svg',
//       'https://res.cloudinary.com/dxluokypg/image/upload/v1682614938/profile4.png_ubdjcv.svg'
//     ]
//   },
//   {
//     // title: 'Total 3 users',
//     // description: 'Support',
//     // content: ' Edit Role',
//     images: [
//       'https://res.cloudinary.com/dxluokypg/image/upload/v1682595163/profile.png_p7dlsz.svg',
//       'https://res.cloudinary.com/dxluokypg/image/upload/v1682614938/profile2.png_ex2vgw.svg',
//       'https://res.cloudinary.com/dxluokypg/image/upload/v1682614938/profile3.png_we8ngj.svg',
//       'https://res.cloudinary.com/dxluokypg/image/upload/v1682614938/profile4.png_ubdjcv.svg'
//     ]
//   },
// ];

function Roles() {
  const navigate = useNavigate()

  const name=useSelector((state)=>state.globalData.name);
  const count=useSelector((state)=>state.globalData.notificationCount);
  const dispatch =  useDispatch()


  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [selectAll,setSelectAll]=useState(false);
  const [checkedState,setCheckedState]=useState({
    userMangement:{
      read:false,
      edit:false,
    },
    userList:{
      read:false,
      edit:false,
    },
    contentManagement:{
      read:false,
      edit:false,
    },
    form:{
      read:false,
      edit:false,
    },



  })
  const [open1, setOpen1] = React.useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);

  const [checked, setChecked] = React.useState(true);

  

  const handleSelect=(name,index)=>{

    // console.log(index);
    // console.log(name);

    setSelectAll(false);
    setCheckedState(prev=>{

      let vname={
        read:false,
        edit:false,
      }
      if(checkedState[name]!==null)
      {

     
      let vname={
        read:checkedState[name].read,
        edit:checkedState[name].edit,
      }

      // console.log(vname)
    }

      if(index===0)
      {
       
        vname={
          edit:checkedState[name].edit,
          read:!checkedState[name].read,
          
        }
      
        // console.log(vname)
      }
      else
      {
        vname={
          read:checkedState[name].read,
          edit:!checkedState[name].edit,
        }
      }

    
      return{
        ...prev,[name]:vname
      }
    })

    // console.log(checkedState)

  }


  const handleSelectAll=()=>
  {
    setSelectAll(prev=>!prev);
    setCheckedState(prev=>{

      
      return{
        userMangement:{
          read:!selectAll,
          edit:!selectAll,
        },
        userList:{
          read:!selectAll,
          edit:!selectAll,
        },
        contentManagement:{
          read:!selectAll,
          edit:!selectAll,
        },
        form:{
          read:!selectAll,
          edit:!selectAll,
        },
      }
      
  
  
  
    })
  }


  const [data, setData] = useState([])
  const [getRoles, setGetRoles] = useState([])

  const getallRoles = async () => {
    try {
        const res = await axios.get(
            `${process.env.REACT_APP_STEELADMIN}/superAdmin/getAllRoles`,
            {
                headers: {
                    "Accept": "*/*"
                    
                }
            }
        )
        setData(res.data)
        // console.log(res.data)
    } catch (error) {
        console.log(error)
    }
}

useEffect(() => {
  getallRoles()
}, [])





  return (
    <div className={RolesStyles.RolesMain}>
      <Box className={RolesStyles.RolesData} >
        {data.map((item) => (
          <Card sx={{ minWidth: 350, maxWidth: 350, margin: 2, pl: '1%', pt: '1%', pb: '1%', cursor: 'pointer' }} key={item.title}>
            <CardContent >
              <Box className={RolesStyles.RolesCard}>
                <Box  >
                  <Typography variant="h4" className={RolesStyles.RolesTitle} >
                  {item.descr}
                  </Typography>
                </Box>
                <Box className={RolesStyles.RolesProfile}>
                {setimg.map((item) => (
                    item.images.map((image) => (
                      <img src={image} alt={item.title} />
                    ))
                  ))}
                </Box>
              </Box>

              <Box>
              <Typography variant="h6" >
                {item.name}
              </Typography>
              <Button className={RolesStyles.RolesBtn} variant="text" onClick={handleOpen1} >Edit Role</Button>
              </Box>
              <CardActions sx={{ '& .MuiModal-container': { backgroundColor: 'transparent' } }} className={RolesStyles.AddRoles}>
                
                <Modal
                  open={open1}
                  onClose={handleClose1}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                  sx={{ backgroundColor: 'transparent !important' }}
                  BackdropProps={{
                    timeout: 500,
                    style: { backgroundColor: '#454545',opacity:'30%' } 
                  }}
                  slotProps={{
                    backdrop: {
                      timeout: 500,
                    },
                  }
        }

                >


                  <Box sx={{ ...style, width: 800, }} className={RolesStyles.RolesModal} >
                    <form>
                      <Typography variant='h2' >Edit roles</Typography>
                      <Typography variant='h3'>Set Role Permissions</Typography>
                      <input type='serach' placeholder='Role Name'></input>


                      <Box className={RolesStyles.RolesPermission}>
                        <label>Role Permissions</label>

                        <FormGroup className={RolesStyles.RolesGroup} >
                          <FormControlLabel control={<Checkbox onChange={handleSelectAll}  checked={selectAll}/>} label="Select All" />
                        </FormGroup>
                      </Box>

                       

                      <Box className={RolesStyles.Rolecheck}>
                        <label>User Management</label>
                        <FormGroup className={RolesStyles.RolesCheckGroup} >
                          <FormControlLabel control={<Checkbox  onChange={()=>handleSelect("userMangement",0)} value={"Read"} name='userM0' checked={checkedState.userMangement.read} />} label="Read" />

                          <FormControlLabel control={<Checkbox onChange={()=>handleSelect("userMangement",1)} value={"Edit"} name='userM1' checked={checkedState.userMangement.edit} />} label="Edit" />
                        </FormGroup>
                      </Box>

                      <Box className={RolesStyles.Rolecheck}>
                        <label>User List</label>
                        <FormGroup className={RolesStyles.RolesCheckGroup}>
                          <FormControlLabel control={<Checkbox onChange={()=>handleSelect("userList",0)} value={"Read"} name='userM2' checked={checkedState.userList.read} />} label="Read" />

                          <FormControlLabel control={<Checkbox onChange={()=>handleSelect("userList",1)} value={"Edit"} name='userM3' checked={checkedState.userList.edit} />} label="Edit" />
                        </FormGroup>
                      </Box>
                      <Box className={RolesStyles.Rolecheck} >
                        <label>contentManagement</label>
                        <FormGroup className={RolesStyles.RolesCheckGroup} style={{ display: 'flex' }}>
                          <FormControlLabel control={<Checkbox onChange={()=>handleSelect("contentManagement",0)} value={"Read"} name='userM4' checked={checkedState.contentManagement.read} />} sx={{ display: 'flex' }} label="Read" />

                          <FormControlLabel control={<Checkbox onChange={()=>handleSelect("contentManagement",1)} value={"Edit"} name='userM5' checked={checkedState.contentManagement.edit} />} sx={{ display: 'flex' }} label="Edit" />
                        </FormGroup>
                      </Box>
                      <Box className={RolesStyles.Rolecheck} >
                        <label>form</label>
                        <FormGroup className={RolesStyles.RolesCheckGroup}>
                          <FormControlLabel control={<Checkbox onChange={()=>handleSelect("form",0)} value={"Read"} name='userM6' checked={checkedState.form.read} />} label="Read" />

                          <FormControlLabel control={<Checkbox onChange={()=>handleSelect("form",1)} value={"Edit"} name='userM7' checked={checkedState.form.edit} />} label="Edit" />
                        </FormGroup>
                      </Box>

                      <Box className={RolesStyles.FooterMainBtn} >
                        <Button variant="text" className={RolesStyles.FooterBtn} onClick={handleClose1}>Discard</Button>
                        <Button variant="contained" className={RolesStyles.FooterSubmit}>Submit</Button>
                      </Box>
                    </form>
                  </Box>

                </Modal>
              </CardActions>

            </CardContent>
          </Card>

        ))}
        <Card
          sx={{
            minWidth: 350, maxWidth: 545,
            margin: 2,
            pl: '2%',
            pt: '2%',
            pb: '2%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',

          }}
        >
          <CardActions className={RolesStyles.AddRoles}>
            <Button variant="contained" className={RolesStyles.RolesBtn} onClick={() => {navigate('/add roles'); handleOpen()}}>Add New Role</Button>
            <Typography className={RolesStyles.RolesPara} >Add role, if it doesn't exist.</Typography>
          </CardActions>
        </Card>
      </Box>
    </div>
  );
}

export default Roles